import * as aor from "react-admin";
import { ArrayField } from "react-admin";
import CardActions from "@material-ui/core/CardActions";
import React from "react";
import { POLICY_COMPANIES } from "../../common/rolesManagement";
import it from "../../messages/it";

const Actions = ({ permissions, basePath, data }) => (
    <CardActions style={{ zIndex: 2, display: "inline-block", float: "right" }}>
        {permissions &&
            (permissions.includes(POLICY_COMPANIES.UPDATE) ||
                (permissions.includes(POLICY_COMPANIES.UPDATE_SLAVE_ONLY) &&
                    data.master_company_id)) && (
                <aor.EditButton basePath={basePath} record={data} />
            )}
        <aor.ListButton basePath={basePath} />
    </CardActions>
);

const MyLicenceField = ({ data }) => (
    <div>
        {Object.keys(data).length > 0 ? (
            Object.keys(data).map(item => <li>{item.replace(/"/g, "")}</li>)
        ) : (
            <a>{it.missing_licenses}</a>
        )}
    </div>
);
MyLicenceField.defaultProps = { addLabel: true };

export default ({ permissions, ...props }) => (
    <aor.Show
        {...props}
        actions={<Actions permissions={permissions} />}
        title={"resources.companies.nameSingular"}
    >
        <aor.SimpleShowLayout>
            <aor.TextField source="vatin" />
            <aor.TextField source="name" />
            <aor.TextField source="seller_code" />
            <aor.ReferenceField
                source="master_company_id"
                reference="companies"
                allowEmpty
                linkType="show"
            >
                <aor.TextField source="name" />
            </aor.ReferenceField>
            {permissions &&
                permissions.includes(POLICY_COMPANIES.SHOW_LICENSES) && (
                    <ArrayField
                        label="Può gestire installazioni:"
                        source="installation_types"
                    >
                        <MyLicenceField></MyLicenceField>
                    </ArrayField>
                )}
        </aor.SimpleShowLayout>
    </aor.Show>
);



// WEBPACK FOOTER //
// ./src/resources/Companies/Show.js